import { render, staticRenderFns } from "./CreateBuilding.vue?vue&type=template&id=7b058edc"
import script from "./CreateBuilding.vue?vue&type=script&lang=js"
export * from "./CreateBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports